import { Box, Chip } from '@material-ui/core';

export interface TagsDisplayProps {
  tags: string[];
}

export const TagsDisplay: React.FC<TagsDisplayProps> = ({ tags }) => {
  if (!tags || tags.length === 0) {
    return null;
  }

  return (
    <Box display="flex" flexWrap="wrap" style={{ gap: 4 }}>
      {tags.map(tag => (
        <Chip
          key={tag}
          size="small"
          label={tag}
          variant="outlined"
          color="secondary"
        />
      ))}
    </Box>
  );
};
